.message {
  &.input {
    color: var(--input-color);
  }

  &.emphasized,
  &.subheader {
    color: var(--accent-color);
  }
}

.scrollTarget {
  scroll-margin-block-start: var(--inner-padding);
}
